// Library Imports
import { ThemeProvider } from '@mui/material';
import { useSelector } from 'react-redux';

// Local Imports
import { theme } from './utils/Theme/theme';
import Router from './router';
import { NoInternetScreen } from './components/NoInternet';
import { useConnectionStatus } from './utils';
import { useEffect } from 'react';
import { getIsProd } from './redux/constant';
import { initSentry } from './redux/logger';

function App() {
  const connectionStatus = useSelector(state => state?.connection)
  useConnectionStatus()
  const user = useSelector((state) => state.currentUser);
  const isProd = getIsProd();

  useEffect(() => {
    initSentry(user, isProd)
  }, [isProd]);

  return (
    <ThemeProvider theme={theme}>
      {connectionStatus?.isOnline ? (
        <Router />
      ) : (
        <NoInternetScreen />
      )}
    </ThemeProvider>
  );
}

export default App;
